<div class="loader-wrapper">
<div class="loading-indicator-animated">
  <span class="left-oval-shaped"></span>
  <span></span>
  <span></span>
  <span></span>
  <span class="right-oval-shaped"></span>
</div>
<div class="loading-text">
  {{"loaderText" | transloco}}
</div>
</div>